const TZ = "Asia/Kolkata";

export function fmtIST(d, withSeconds = false) {
  if (!d) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ,
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
    ...(withSeconds ? { second: "2-digit" } : {}),
    hour12: false,
  }).format(new Date(d));
}

export function fmtDateIST(d) {
  if (!d) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ, day: "2-digit", month: "short", year: "numeric",
  }).format(new Date(d));
}

export function istTodayStr() {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());
}

export function nowISTLocalInput() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(new Date());
  const p = Object.fromEntries(parts.filter((x) => x.type !== "literal").map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour === "24" ? "00" : p.hour}:${p.minute}`;
}

export function istLocalInput(d) {
  if (!d) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(new Date(d));
  const p = Object.fromEntries(parts.filter((x) => x.type !== "literal").map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour === "24" ? "00" : p.hour}:${p.minute}`;
}

export function nowLocalInput() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}

export function presetRange(preset) {
  const [y, m, dd] = istTodayStr().split("-").map(Number);
  const today = new Date(Date.UTC(y, m - 1, dd));
  const iso = (dt) => dt.toISOString().slice(0, 10);
  const pad = (n) => String(n).padStart(2, "0");
  switch (preset) {
    case "today":
      return { from: iso(today), to: iso(today) };
    case "yesterday": {
      const d = new Date(today);
      d.setUTCDate(d.getUTCDate() - 1);
      return { from: iso(d), to: iso(d) };
    }
    case "week": {
      const dow = (today.getUTCDay() + 6) % 7; // Monday = 0
      const mon = new Date(today);
      mon.setUTCDate(mon.getUTCDate() - dow);
      return { from: iso(mon), to: iso(today) };
    }
    case "month":
      return { from: `${y}-${pad(m)}-01`, to: iso(today) };
    case "prevMonth": {
      const py = m === 1 ? y - 1 : y;
      const pm = m === 1 ? 12 : m - 1;
      const last = new Date(Date.UTC(py, pm, 0));
      return { from: `${py}-${pad(pm)}-01`, to: iso(last) };
    }
    case "year":
      return { from: `${y}-01-01`, to: iso(today) };
    default:
      return { from: "", to: "" };
  }
}

export const inr = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(n ?? 0);
